import {
  OverviewPage,
  OverviewPanelsRow,
  Mock5LineIconPanel,
  GateInCompletedPanel,
  GateOutCompletedPanel,
  ContainersInDepotPanel,
  ContainerStatusPanel,
  ContainerTypePanel,
  GateCompletedBarPanel,
  ExpectedGateBarPanel,
  LiveGateActivityTablePanel,
  OperationsPanel,
  GateTablePanel,
  AlertsPanel,
  OverviewPanelsRows,
  ContainerLocationPanel,
} from './OverviewComponents';
import {
  useAutoScale,
  useIsSmallScreen,
  useOverviewQuery,
  useStatesWithFilterCounter,
} from '../../hooks';
import { RoleGuard } from '../../routes';
import { showToRoles } from '../../utils';
import { useStoreUser } from '../../context';
import { BelongsToFilterSelects, Select, Typography } from '../../design-system';
import { lastVisitedAtOptions } from '../../const';
import {
  DepotOccupancyByAreaPanel,
  DepotOccupancyByContainerTypePanel,
  DepotOccupancySummaryPanels,
  DepotOccupancyTrendPanel,
} from './DepotOccupancyPanels';
import { i18n } from '../../i18n';

export const Overview = () => {
  const { user } = useStoreUser();
  const isSmallScreen = useIsSmallScreen();

  const [states, setStates, filteredStates] = useStatesWithFilterCounter(
    {
      lastDays: 0,
      yardId: '',
    },
    {
      lastDays: 30,
    },
  );

  const { data } = useOverviewQuery(filteredStates);
  const elementRef = useAutoScale();

  return (
    <RoleGuard
      roles={[
        'SUPER_ADMIN',
        'YARD_COMPANY_ADMIN',
        'YARD_COMPANY_EMPLOYEE',
        'YARD_COMPANY_VIEWER',
        'YARD_MANAGER',
        'YARD_DISPATCHER',
        'VENDOR',
      ]}
    >
      <OverviewPage id="overview-page" ref={elementRef}>
        {isSmallScreen && (
          <OverviewPanelsRow columns="30rem 30rem" minRow="max-content">
            {!showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER', 'VENDOR'], user) && (
              <BelongsToFilterSelects
                handleChange={(data) => setStates('force', { yardId: data.yardId })}
                filtersType="overview"
                withoutLabel
                isYardRequired
                isSubmitClicked
              />
            )}
            <Select
              options={lastVisitedAtOptions}
              value={states.lastDays}
              onChange={(e) => setStates('force', { lastDays: e.target.value })}
            />
          </OverviewPanelsRow>
        )}
        {!!data && (
          <>
            <OverviewPanelsRow>
              <GateInCompletedPanel data={data} />
              <GateOutCompletedPanel data={data} />
              <ContainersInDepotPanel data={data} />
              <Mock5LineIconPanel />
            </OverviewPanelsRow>
            {showToRoles('adminRead', user) && (
              <OverviewPanelsRow
                columns={'repeat(2, max-content) 30rem minmax(max-content, 1fr)'}
                minRow={'25rem'}
              >
                <ContainerStatusPanel data={data} />
                <ContainerTypePanel data={data} />
                <GateCompletedBarPanel data={data} />
                <LiveGateActivityTablePanel data={data} />
              </OverviewPanelsRow>
            )}
            {showToRoles(['VENDOR'], user) && (
              <OverviewPanelsRow
                columns={'max-content 80rem minmax(max-content, 1fr)'}
                minRow={'25rem'}
              >
                <OverviewPanelsRows>
                  <ContainerStatusPanel data={data} />
                  <ContainerTypePanel data={data} />
                </OverviewPanelsRows>
                <ContainerLocationPanel data={data} />
                <LiveGateActivityTablePanel data={data} />
              </OverviewPanelsRow>
            )}
            <OverviewPanelsRow columns={'max-content max-content'} minRow={'25rem'}>
              <OperationsPanel data={data} />
              <GateTablePanel data={data} />
              <AlertsPanel data={data} />
            </OverviewPanelsRow>
            <Typography variant="h5" weight="semibold" color="--gray-100">
              {i18n.t('pages.overview.depotOccupancy.title')}
            </Typography>
            <OverviewPanelsRow minRow="max-content">
              <DepotOccupancySummaryPanels data={data.depotOccupancy} />
            </OverviewPanelsRow>
            <OverviewPanelsRow columns="1fr max-content" minRow="max-content">
              <ExpectedGateBarPanel data={data} lastDays={Number(states.lastDays) || 30} />
              <DepotOccupancyByAreaPanel data={data.depotOccupancy} />
            </OverviewPanelsRow>
            <OverviewPanelsRow columns="max-content 1fr" minRow="30rem">
              <DepotOccupancyByContainerTypePanel data={data.depotOccupancy} />
              <DepotOccupancyTrendPanel
                data={data.depotOccupancy}
                lastDays={Number(states.lastDays) || 30}
              />
            </OverviewPanelsRow>
          </>
        )}
      </OverviewPage>
    </RoleGuard>
  );
};
